import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MaterialIconsService {

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'logout_custom',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/logout.svg'));
    iconRegistry.addSvgIcon(
      'change-device-box',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/change-device.svg'));

    // Package Status Icons
    iconRegistry.addSvgIcon(
      'package-pickup',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/pickup.svg'));
    iconRegistry.addSvgIcon(
      'package-logical-pickup',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/logical-pickup.svg'));
    iconRegistry.addSvgIcon(
      'package-terminal',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/terminal.svg'));
    iconRegistry.addSvgIcon(
      'package-delivery',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/delivery.svg'));
    iconRegistry.addSvgIcon(
      'package-hold',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/hold.svg'));
    iconRegistry.addSvgIcon(
      'package-delivered',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/delivered.svg'));
    iconRegistry.addSvgIcon(
      'package-returned',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/returned.svg'));
    iconRegistry.addSvgIcon(
      'tracking-url',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/order-status/tracking-url.svg'));
  }
}
